import jwt_decode from 'jwt-decode'
import { useAuthStore } from '../pinia/auth'

export default {
  setToken({ commit }, token) {
    const decoded = jwt_decode(token)
    commit('setSession', decoded)
    //commit('setUserAvatarUrl', null)
    commit('setToken', token)
    //commit('setPharmaceuticalDomainConfig', token)
  },
  clearCredentials({ commit }) {
    commit('setToken', null)
    commit('setSession', null)
    commit('setUserAvatarUrl', null)
    const piniaAuthStore = useAuthStore()
    piniaAuthStore.setInitiated(false)
  },
  setUserAvatarUrl({ commit }, avatarUrl) {
    commit('setUserAvatarUrl', avatarUrl)
  },
  setShowSurvey({ commit }, show) {
    commit('setShowSurvey', show)
  },
}
